import React from 'react';
import CheckIcon from "../SVG/CheckIcon";
import CheckIconGreen from "../SVG/CheckIconGreen";

const CheckedComponent = ({ items = [] }) => {
    return (
        <div className="checked_list_body">
            {items?.map((item, index) => <div key={`${index}__checkedKey`} className={`list_item`}>
                <div className={`icon`}>
                    {!item?.isTrue ? <CheckIcon/> : <CheckIconGreen/>}
                </div>
                <p>{item?.text || ''}</p>
            </div>)}
        </div>
    );
}

export default CheckedComponent
